module.exports = __webpack_public_path__ + "img/gc_country_flag_me.52f620fb.svg";